import {
  casinoMenuItem,
  cyberSportMenuItem,
  liveCasinoMenuItem,
  sportLiveMenuItem,
  sportMenuItem,
  tournamentsMenuItem,
} from '@/constants';

import type { NavMenuItem } from '@/types';

export const getDesktopNavMenu = (): Array<NavMenuItem> => [
  casinoMenuItem,
  liveCasinoMenuItem,
  // TODO Временно скрываем в рамках MWL-6896
  // pokerMenuItem,
  sportMenuItem,
  sportLiveMenuItem,
  cyberSportMenuItem,
  tournamentsMenuItem,
];
